(function() {
  "use strict";
  angular.module("marketPlace.following", []);
})();
